export const status = {
  sent: 'Enviado',
  scheduled: 'Agendado',
  canceled: 'Cancelado',
  enqueued: 'Enfileirada'
}
